import { render, staticRenderFns } from "./SelectTask.vue?vue&type=template&id=21d1a8f0&scoped=true"
import script from "./SelectTask.vue?vue&type=script&lang=js"
export * from "./SelectTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1a8f0",
  null
  
)

export default component.exports